import urls from '@/utils/urls/urls'
import cl from '@/utils/console/cl'
import BlogCard from './BlogCard'
const BlogIndex = async () => {
    const res = await fetch(urls?.blog)
    const data = await res.json()
    const blog = Array.isArray(data?.data) ? data?.data : [];
    // cl("blog", blog)

    return (
        <>
            <div className="blog-area py-120">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6 mx-auto">
                            <div
                                className="site-heading text-center wow fadeInDown"
                                data-wow-delay=".25s"
                            >
                                <span className="site-title-tagline">
                                    <i className="fas fa-solar-panel" /> Our Blog
                                </span>
                                <h2 className="site-title">
                                    Our Latest News &amp; <span>Blog</span>
                                </h2>
                                <div className="heading-divider" />
                            </div>
                        </div>
                    </div>
                    <div className="row g-4">
                        {
                            blog?.slice(0, 3).map((item: any) => (
                                <div className="col-md-6 col-lg-4" key={item.id}>
                                    <BlogCard item={item} />
                                </div>
                            ))
                        }
                        {/* <div className="col-md-6 col-lg-4">
                            <div className="blog-item wow blog-card-align fadeInUp" data-wow-delay=".25s">
                                <div className="blog-item-img">
                                    <img src="../assets/img/blogs/44.jpg" alt="Thumb" />
                                </div>
                                <div className="blog-date">
                                    <strong>20</strong>
                                    <span>Aug</span>
                                </div>
                                <div className="blog-item-info">
                                    <div className="blog-item-meta">
                                        <ul>
                                            <li>
                                                <Link href="#">
                                                    <i className="far fa-user-circle" /> By Alicia Davis
                                                </Link>
                                            </li>
                                            <li>
                                                <Link href="#">
                                                    <i className="far fa-comments" /> 2.5k Comments
                                                </Link>
                                            </li>
                                        </ul>
                                    </div>
                                    <h4 className="blog-title">
                                        <Link href="blogs/123">
                                            Pailung High-Speed Knitting Machines Boost Productivity While
                                        </Link>
                                    </h4>
                                    <p>
                                        Textile manufacturers have to improve their efficiency. They’re under constant pressure to produce more, faster, and for less cost. Although that might seem difficult.
                                    </p>
                                    <Link className="theme-btn" href="blogs/123">
                                        Read More
                                        <i className="fas fa-arrow-right" />
                                    </Link>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 col-lg-4">
                            <div className="blog-item wow blog-card-align fadeInDown" data-wow-delay=".25s">
                                <div className="blog-item-img">
                                    <img src="../assets/img/blogs/22.jpg" alt="Thumb" />
                                </div>
                                <div className="blog-date">
                                    <strong>25</strong>
                                    <span>Aug</span>
                                </div>
                                <div className="blog-item-info">
                                    <div className="blog-item-meta">
                                        <ul>
                                            <li>
                                                <Link href="#">
                                                    <i className="far fa-user-circle" /> By Alicia Davis
                                                </Link>
                                            </li>
                                            <li>
                                                <Link href="#">
                                                    <i className="far fa-comments" /> 1.2k Comments
                                                </Link>
                                            </li>
                                        </ul>
                                    </div>
                                    <h4 className="blog-title">
                                        <Link href="blogs/123">
                                            Generator internet repeat tend word chunk necessary.
                                        </Link>
                                    </h4>
                                    <p>
                                        The Knitting Fabric Management System (KFMS) stores an archive of knitting detail resources. Every fabric that a Pailung knitting machine produces can be saved in this database.

                                    </p>
                                    <Link className="theme-btn" href="blogs/123">
                                        Read More
                                        <i className="fas fa-arrow-right" />
                                    </Link>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 col-lg-4">
                            <div className="blog-item wow blog-card-align fadeInUp" data-wow-delay=".25s">
                                <div className="blog-item-img">
                                    <img src="../assets/img/blogs/33.jpg" alt="Thumb" />
                                </div>
                                <div className="blog-date">
                                    <strong>28</strong>
                                    <span>Aug</span>
                                </div>
                                <div className="blog-item-info">
                                    <div className="blog-item-meta">
                                        <ul>
                                            <li>
                                                <Link href="#">
                                                    <i className="far fa-user-circle" /> By Alicia Davis
                                                </Link>
                                            </li>
                                            <li>
                                                <Link href="#">
                                                    <i className="far fa-comments" /> 2.8k Comments
                                                </Link>
                                            </li>
                                        </ul>
                                    </div>
                                    <h4 className="blog-title">
                                        <Link href="blogs/123">
                                            Survived only five centuries but also the leap into.
                                        </Link>
                                    </h4>
                                    <p>
                                        AlterKnit is an enhanced version of inverse plating, knitting alternate yarns into the fabric using circular knitting machines. This technology creates crisp patterns with sharp borders, offering unlimited design
                                    </p>
                                    <Link className="theme-btn" href="blogs/123">
                                        Read More
                                        <i className="fas fa-arrow-right" />
                                    </Link>
                                </div>
                            </div>
                        </div> */}
                    </div>
                </div>
            </div>
        </>
    )
}

export default BlogIndex
